import React from 'react';
import { FiCircle, FiCheckCircle } from 'react-icons/fi';
import { Container, Label } from './styles';
var CheckBox = function (_a) {
    var field = _a.field, onChange = _a.onChange;
    return (React.createElement(Container, { onClick: function () { return onChange(field.value === 'true' ? 'false' : 'true'); } },
        field.value === 'true' ? (React.createElement(FiCheckCircle, { size: 18 })) : (React.createElement(FiCircle, { size: 18 })),
        React.createElement(Label, null, field.label)));
};
export default CheckBox;
